<template>
  <div class="xcard">
    <v-toolbar-title class="mb-5 py-2" style="border-bottom: 1px solid #d4dbe0">
      <span>REGISTRO DE UNIDADES DE MEDIDA</span>
    </v-toolbar-title>

    <v-row>
      <v-col cols="12" md="9" xl="10" class="pa-2 pb-0">
        <v-btn
          small
          color="primary"
          class="mr-2"
          @click="$refs.modalFormUnidadMedidaRef.abrir('registrar', [])"
          title="Registrar">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn
          small
          class="mr-2"
          :disabled="item == null"
          @click="$refs.modalFormUnidadMedidaRef.abrir('editar', item)"
          title="Editar">
          <v-icon>mdi-pencil</v-icon>

          Editar
        </v-btn>

        <v-btn small class="mr-2" @click="listar" title="Recargar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2" class="pa-2 pb-0">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="updateSearchQuery"></v-text-field>
      </v-col>

      <v-col cols="12" class="pa-2 pb-4">
        <ListadoUnidadMedida ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalFormUnidadMedida ref="modalFormUnidadMedidaRef" :nombreRecurso="nombreRecurso" @actualizarListado="listar" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ListadoUnidadMedida from '../views/ListadoUnidadMedida.vue';
import ModalFormUnidadMedida from '../components/ModalFormUnidadMedida.vue';
import UnidadMedidaServices from '../services/unidadMedida';
import LayoutMixin from '../mixins/layout-mixin';

export default {
  name: 'UnidadesMedida',
  mixins: [LayoutMixin],
  components: {
    ListadoUnidadMedida,
    ModalFormUnidadMedida,
  },
  data() {
    return {
      servicioListarItems: UnidadMedidaServices.get,
      nombreRecurso: 'UNIDADES DE MEDIDA',
    };
  },
  watch: {
    '$store.state.CARGO.sede.id'() {
      this.listar();
    },
  },
  mounted() {
    this.listar();
  },
  methods: {
    async listar() {
      this.listarMixin();
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}
</style>